import Link from "next/link";
import { Col, Row } from "react-styled-flexboxgrid";

const PWAStoreButtons = () => {
  return (
    <Row center="xs" style={{ paddingTop: "2rem" }}>
      <Col xs={6}>
        <Row end="xs">
          <Link href="/pwa/install-on-iphone">
            <img
              src="/img/buttons/iphone.svg"
              width="145"
              height="50"
              style={{ cursor: "pointer", marginRight: "4px" }}
            />
          </Link>
        </Row>
      </Col>
      <Col xs={6}>
        <Row>
          <Link href="/pwa/install-on-android">
            <img
              src="/img/buttons/google-play.svg"
              width="145"
              height="50"
              style={{ cursor: "pointer", marginLeft: "4px" }}
            />
          </Link>
        </Row>
      </Col>
    </Row>
  );
};

export default PWAStoreButtons;
